import { BASE_URLS } from 'constants/urls';

// Import and export SVG and image files
export const AxisBankSVG = `${BASE_URLS.ASSETS}/assets/img/axisBank.svg`;
export const SpoctoxSVG = `${BASE_URLS.ASSETS}/assets/img/yucollect.svg`;
export const BellSVG = `${BASE_URLS.ASSETS}/assets/img/bell.svg`;
export const UploadLocationSVG = `${BASE_URLS.ASSETS}/assets/img/uploadLocation.svg`;
export const BlankRecordSVG = `${BASE_URLS.ASSETS}/assets/img/blankRecords.svg`;
export const CloseSVG = `${BASE_URLS.ASSETS}/assets/img/Close.svg`;
export const TrashSVG = `${BASE_URLS.ASSETS}/assets/img/trash.svg`;
export const PencilSVG = `${BASE_URLS.ASSETS}/assets/img/pencil.svg`;
export const IVRSVG = `${BASE_URLS.ASSETS}/assets/img/ivr.svg`;
export const EmailSVG = `${BASE_URLS.ASSETS}/assets/img/email.svg`;
export const WhatsappSVG = `${BASE_URLS.ASSETS}/assets/img/whatsapp.svg`;
export const SMS = `${BASE_URLS.ASSETS}/assets/img/sms.svg`;
export const ConversationBotSVG = `${BASE_URLS.ASSETS}/assets/img/conversationBot.svg`;
export const RecordSVG = `${BASE_URLS.ASSETS}/assets/img/Record.svg`;
export const VerticalDots = `${BASE_URLS.ASSETS}/assets/img/verticalDots.svg`;
export const RecordSuccess = `${BASE_URLS.ASSETS}/assets/img/record-success.svg`;
export const HdfcLogo = `${BASE_URLS.ASSETS}/assets/img/hdfc.png`;
export const MarkerIcon = `${BASE_URLS.ASSETS}/assets/img/marker-icon.png`;
export const WhatsappLogo = `${BASE_URLS.ASSETS}/assets/img/whatsapp-logo.svg`;
export const TubelightLogo = `${BASE_URLS.ASSETS}/assets/img/tubelight.svg`;
export const MergeHistoricDataSVG = `${BASE_URLS.ASSETS}/assets/img/merge-historic-data.svg`;
export const BackgroundImage = `${BASE_URLS.ASSETS}/assets/img/login-bg.png`;
export const YCIcon = `${BASE_URLS.ASSETS}/assets/img/yc-icon.svg`;
export const NoCommentsIcon = `${BASE_URLS.ASSETS}/assets/img/no-comments.svg`;
export const groupIcon = `${BASE_URLS.ASSETS}/assets/img/group.svg`;
export const VariableIcon = `${BASE_URLS.ASSETS}/assets/img/variable.svg`;
export const MilestoneIcon = `${BASE_URLS.ASSETS}/assets/img/milestone.svg`;
export const ConveyanceIcon = `${BASE_URLS.ASSETS}/assets/img/conveyance.svg`;
export const AttachmentIcon = `${BASE_URLS.ASSETS}/assets/img/attachment.svg`;
export const AgentReassignAH = `${BASE_URLS.ASSETS}/assets/img/agent-reassign-ah.svg`;
export const CallAH = `${BASE_URLS.ASSETS}/assets/img/call-ah.svg`;
export const ChannelReassignAH = `${BASE_URLS.ASSETS}/assets/img/channel-reassign-ah.svg`;
export const DigitalAH = `${BASE_URLS.ASSETS}/assets/img/digital-ah.svg`;
export const FieldAH = `${BASE_URLS.ASSETS}/assets/img/field-ah.svg`;
export const Star = `${BASE_URLS.ASSETS}/assets/img/star.svg`;
export const Call = `${BASE_URLS.ASSETS}/assets/img/call.svg`;
export const Digital = `${BASE_URLS.ASSETS}/assets/img/digital.svg`;
export const Field = `${BASE_URLS.ASSETS}/assets/img/field.svg`;
export const MailOpen = `${BASE_URLS.ASSETS}/assets/img/mail-open.svg`;
export const LineArt = `${BASE_URLS.ASSETS}/assets/img/lineart.svg`;
export const AgencyOnboardingSignInBg = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/sign-in-bg.png`;
export const IPhone = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/iPhone-13.svg`;
export const RegisterCompany = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/register-company.png`;
export const CardBG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/card.svg`;
export const FolderSVG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/folders.svg`;
export const CallSVG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/call-svg.svg`;
export const CallSVG2 = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/call-svg-2.svg`;
export const FieldSVG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/field-svg.svg`;
export const DigitalSVG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/digital-svg.svg`;
export const ProfilePageIllustration = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/illustartion.png`;
export const LoanSVG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/loan.svg`;
export const FolderSVGV2 = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/folder.svg`;
export const AddIcon = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/add-icon.svg`;
export const GoldenSeal = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/golden-seal.svg`;

export const AllocationMasterSVG = `${BASE_URLS.ASSETS}/assets/img/allocation_master.svg`;
export const ComingSoonSVG = `${BASE_URLS.ASSETS}/assets/img/comingSoon.svg`;
export const ComplianceSVG = `${BASE_URLS.ASSETS}/assets/img/compliance.svg`;
export const ComputerGroupSVG = `${BASE_URLS.ASSETS}/assets/img/computerGroup.svg`;
export const ErrorPageSVG = `${BASE_URLS.ASSETS}/assets/img/errorPage.svg`;
export const IsolationModeSVG = `${BASE_URLS.ASSETS}/assets/img/isolation-mode.svg`;
export const LockedFilesSVG = `${BASE_URLS.ASSETS}/assets/img/lockedFiles.svg`;
export const MarkerIconSVG = `${BASE_URLS.ASSETS}/assets/img/markerIcon.svg`;
export const MobileSVG = `${BASE_URLS.ASSETS}/assets/img/mobile.svg`; // assets/mobile.svg
export const NoRecordsSVG = `${BASE_URLS.ASSETS}/assets/img/noRecords.svg`;
export const NotFoundPNG = `${BASE_URLS.ASSETS}/assets/img/notFound.png`;
export const VimeoThumbnail = `${BASE_URLS.ASSETS}/img/vimeo-thumbnail.png`;

export const CardBG2 = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/card-2.svg`;
export const CardBackgroundPNG = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/card-bg.png`;
export const ProfileCardData = `${BASE_URLS.ASSETS}/assets/img/agency-onboarding-v2/007_Profile Card Created.json`;
